import { scrollToElement } from '../../services/Scroll'

document.addEventListener('nette:valid', (event) => {
    if (event.defaultPrevented) {
        return
    }

    const element = event.target

    if (element.tagName.toLowerCase() != 'button') {
        const errorElement = element.parentNode.querySelector('.InputError')
        if (errorElement) {
            element.removeAttribute('aria-invalid')
            element.removeAttribute('aria-describedby')
            element.parentNode.removeChild(errorElement)
        }
    }

    element.classList.remove('has-error')
    element.classList.add('is-valid')
})

document.addEventListener('nette:invalid', (event) => {
    if (event.defaultPrevented) {
        return
    }

    const element = event.target

    let errorElement = element.parentNode.querySelector('.InputError')

    if (!errorElement) {
        errorElement = document.createElement('div')
        errorElement.className = 'InputError'
    }

    if (!errorElement.id) {
        errorElement.id = 'error-' + Date.now()
    }

    errorElement.innerHTML = element.getAttribute('data-nette-error')
    element.parentNode.appendChild(errorElement)
    element.classList.add('has-error')
    element.classList.remove('is-valid')
    element.setAttribute('aria-invalid', 'true')
    element.setAttribute('aria-describedby', errorElement.id)
    errorElement.setAttribute('role', 'alert')
})

/**
 * Je prvek skutečně na vidění? Nestačí, že existuje — antispamový honeypot je plnohodnotný
 * input odsunutý přes transform o −9999 px, takže chybová hláška u něj sice vznikne, ale
 * uživatel ji nikdy neuvidí (#3743).
 */
const isVisiblyPlaced = (element) => {
    if (!element) {
        return false
    }

    const rect = element.getBoundingClientRect()

    if (rect.width <= 0 || rect.height <= 0) {
        return false
    }

    // absolutní pozice v dokumentu — odsunutý prvek má zápornou
    if (rect.left + window.scrollX < 0 || rect.top + window.scrollY < 0) {
        return false
    }

    const style = getComputedStyle(element)

    return style.visibility !== 'hidden' && style.opacity !== '0'
}

/**
 * Poslední záchrana: formulář neprošel, ale žádná hláška není vidět. Uživatel by jinak jen
 * klikal na odeslat a nic by se nedělo (#3743) — což se u žádosti o grant reálně stalo.
 */
const showFormLevelError = (form) => {
    let box = form.querySelector('.FormError')

    if (!box) {
        box = document.createElement('div')
        box.className = 'FormError'
        box.setAttribute('role', 'alert')
        form.insertBefore(box, form.firstChild)
    }

    // Text schválně neprozrazuje, že zabrala ochrana proti spamu — návod pro roboty
    // a pro uživatele matoucí. Načtení stránky znovu je řešení pro obě příčiny.
    box.textContent = 'Formulář se nepodařilo odeslat. Načtěte prosím stránku znovu, '
        + 'vyplňte formulář a zkuste to znovu.'

    box.hidden = false

    return box
}

/**
 * Odsazení pro odscrollování — musí odpovídat výšce fixní hlavičky, jinak hláška skončí
 * schovaná pod ní. Pozor: scrollToElement bere objekt options, ne číslo; dřívější volání
 * `scrollToElement(el, -120)` se tiše destrukturovalo na výchozích 20 px (#3743).
 */
const scrollOffset = () => {
    const header = document.querySelector('.Header')
    const height = header ? header.getBoundingClientRect().height : 0

    return Math.round(height) + 40
}

const clearFormLevelError = (form) => {
    const box = form.querySelector('.FormError')

    if (box) {
        box.hidden = true
    }
}

document.addEventListener('nette:form:valid', (event) => clearFormLevelError(event.target))
document.addEventListener('nette:form:invalid', (event) => {
    const form = event.target

    // Vezmeme první hlášku, kterou uživatel skutečně uvidí — ne první v pořadí DOM.
    const visibleError = Array.from(form.querySelectorAll('.InputError')).find(isVisiblyPlaced)

    if (visibleError) {
        clearFormLevelError(form)

        const target = visibleError.closest('.FormItem')
        scrollToElement(target ? target : form, { offset: scrollOffset() })

        return
    }

    scrollToElement(showFormLevelError(form), { offset: scrollOffset() })
})
